import { defineComponent as _defineComponent } from 'vue'
import {useValidatorsStore} from "@/store/validators.store";
import {computed } from "vue";
import {useUserStore} from "@/store/user.store";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ValidatorsDataTable from "@/components/staking/ValidatorsDataTable.vue";
import ValidatorsStatusLabel from "../commons/ValidatorsStatusLabel.vue";
import { ValidatorsDataTableType } from "@/components/staking/ValidatorsDataTable.ts";

// const validatorsStore = useValidatorsStore();

export default /*#__PURE__*/_defineComponent({
  __name: 'StakingData',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();

const isLoggedIn = computed(() => userStore.isLoggedIn);


const __returned__ = { userStore, isLoggedIn, get useValidatorsStore() { return useValidatorsStore }, get useUserStore() { return useUserStore }, get TabView() { return TabView }, get TabPanel() { return TabPanel }, ValidatorsDataTable, ValidatorsStatusLabel, get ValidatorsDataTableType() { return ValidatorsDataTableType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})